<template>
  <div class="paparan-utama">

    <!-- ============ HERO ============
         Sengaja BERBEZA daripada <PageHeader> yang digunakan halaman lain:
         halaman lain = jalur cerah, teks teal, jubin ikon.
         Halaman utama  = panel teal gelap, teks putih terbalik, tiada jubin
         ikon — isyarat visual bahawa ini akar sistem, bukan satu lagi halaman. -->
    <div class="hero mb-4">
      <!-- Latar abstrak analisis statistik: grid, bar, garis aliran, taburan.
           SVG sebaris — tiada aset luar, boleh diskala dan mengikut warna tema. -->
      <svg class="hero__bg" viewBox="0 0 900 280" preserveAspectRatio="xMaxYMid slice" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id="hbar" x1="0" y1="1" x2="0" y2="0">
            <stop offset="0%" stop-color="#7fe9dd" stop-opacity=".04" />
            <stop offset="100%" stop-color="#7fe9dd" stop-opacity=".30" />
          </linearGradient>
          <linearGradient id="harea" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#5fe3d3" stop-opacity=".22" />
            <stop offset="100%" stop-color="#5fe3d3" stop-opacity="0" />
          </linearGradient>
        </defs>

        <!-- grid pengukuran -->
        <g stroke="#a8f0e6" stroke-opacity=".10">
          <path d="M0 70H900M0 120H900M0 170H900M0 220H900" />
          <path d="M540 0V280M600 0V280M660 0V280M720 0V280M780 0V280M840 0V280" />
        </g>

        <!-- bar chart -->
        <g fill="url(#hbar)">
          <rect x="556" y="160" width="30" height="100" />
          <rect x="616" y="122" width="30" height="138" />
          <rect x="676" y="180" width="30" height="80" />
          <rect x="736" y="96" width="30" height="164" />
          <rect x="796" y="138" width="30" height="122" />
          <rect x="856" y="74" width="30" height="186" />
        </g>

        <!-- kawasan + garis aliran -->
        <path d="M540 186 L600 150 L660 166 L720 110 L780 132 L840 84 L900 102 L900 260 L540 260 Z" fill="url(#harea)" />
        <polyline
          points="540,186 600,150 660,166 720,110 780,132 840,84 900,102"
          fill="none" stroke="#7fe9dd" stroke-opacity=".8" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round"
        />
        <g fill="#ffffff" fill-opacity=".85">
          <circle cx="600" cy="150" r="3.5" />
          <circle cx="720" cy="110" r="3.5" />
          <circle cx="840" cy="84" r="3.5" />
        </g>

        <!-- taburan (scatter) -->
        <g fill="#7fe9dd" fill-opacity=".18">
          <circle cx="470" cy="80" r="5" />
          <circle cx="505" cy="130" r="3.5" />
          <circle cx="455" cy="160" r="4" />
          <circle cx="510" cy="206" r="5.5" />
          <circle cx="440" cy="222" r="3" />
        </g>
      </svg>

      <div class="hero__inner">
        <!-- Wordmark survei — pengenalan sistem, hanya di halaman utama -->
        <div class="hero__brand">
          <span class="hero__brand-mark">HIES<span class="hero__brand-slash">/</span>BA</span>
          <span class="hero__brand-year">Analisis</span>
        </div>

        <h1 class="hero__title">
          {{ salam }},
          <span class="hero__name">{{ currentUser }}</span>
        </h1>
        <p class="hero__sub">
          Survei Pendapatan, Perbelanjaan Isi Rumah dan Kemudahan Asas
        </p>

        <!-- Maklumat sesi -->
        <dl class="hero__meta">
          <div class="hero__meta-item">
            <dt>Peranan</dt>
            <dd>{{ perananPenuh }}</dd>
          </div>
          <div class="hero__meta-item">
            <dt>Tarikh</dt>
            <dd>{{ hariIni }}, {{ tarikhHariIni }}</dd>
          </div>
          <div class="hero__meta-item">
            <dt>Masa</dt>
            <!-- tabular-nums: digit tidak "melompat" setiap saat -->
            <dd class="hero__clock">{{ masaSekarang }}</dd>
          </div>
        </dl>
      </div>
    </div>

    <!-- ============ AKSES PANTAS ============ -->
    <!-- Satu kad sahaja; setiap modul ialah satu seksyen dalam grid 2 lajur:
           Pengurusan Pengguna | Pamer Data
           Jadual Awalan       | Lain-lain     -->
    <v-card outlined class="akses">
      <v-card-title class="py-2 akses__tajuk">
        <v-icon small class="mr-2" :color="COL.teal">mdi-lightning-bolt</v-icon>
        Akses Pantas
        <v-spacer></v-spacer>
        <!-- <span class="caption grey--text">Mengikut peranan anda</span> -->
      </v-card-title>
      <v-divider></v-divider>

      <!-- Hiasan abstrak: gelang donut sepusat (seperti carta donut Kadar
           Respon). Opasiti rendah, `pointer-events: none` supaya tidak
           menghalang klik pautan.
           Pusat donut sengaja diletak DI LUAR viewBox (sudut kanan bawah),
           jadi hanya sebahagian gelang kelihatan — ia terpotong oleh birai
           kad (`overflow: hidden`), bukan bulatan penuh.
           Setiap gelang ialah bulatan dengan `stroke-dasharray` = [arka, baki],
           di mana baki = lilitan − arka (C = 2πr). Diputar supaya arka
           terbuka menghadap ke dalam kad. -->
      <svg class="akses__bg" viewBox="0 0 240 160" aria-hidden="true" focusable="false">
        <g transform="translate(232 168)" fill="none" stroke-linecap="butt">
          <!-- Setiap gelang: warna berbeza daripada palet COL (teal/amber/red/
               navy) dan sudut mula berbeza, supaya ia tidak kelihatan seperti
               bar kemajuan yang sama berulang. -->

          <!-- Gelang luar  r=128, C≈804.2 -->
          <circle r="128" stroke="#037769" stroke-opacity=".14" stroke-width="18" />
          <g transform="rotate(-152)">
            <!-- arka 27% teal -->
            <circle r="128" stroke="#0EA5A4" stroke-width="18" stroke-dasharray="217.1 587.1" />
          </g>
          <g transform="rotate(-44)">
            <!-- arka 14% amber -->
            <circle r="128" stroke="#E0A800" stroke-width="18" stroke-dasharray="112.6 691.6" />
          </g>

          <!-- Gelang tengah r=98, C≈615.8 -->
          <circle r="98" stroke="#037769" stroke-opacity=".14" stroke-width="15" />
          <g transform="rotate(-96)">
            <!-- arka 38% navy -->
            <circle r="98" stroke="#0B1F3A" stroke-opacity=".7" stroke-width="15" stroke-dasharray="234 381.8" />
          </g>
          <g transform="rotate(60)">
            <!-- arka 11% red -->
            <circle r="98" stroke="#D9534F" stroke-opacity=".8" stroke-width="15" stroke-dasharray="67.7 548.1" />
          </g>

          <!-- Gelang dalam r=72, C≈452.4 -->
          <circle r="72" stroke="#037769" stroke-opacity=".14" stroke-width="12" />
          <g transform="rotate(-170)">
            <!-- arka 46% mint -->
            <circle r="72" stroke="#5fe3d3" stroke-width="12" stroke-dasharray="208.1 244.3" />
          </g>
          <g transform="rotate(28)">
            <!-- arka 9% amber -->
            <circle r="72" stroke="#E0A800" stroke-opacity=".75" stroke-width="12" stroke-dasharray="40.7 411.7" />
          </g>
        </g>
      </svg>

      <v-card-text class="akses__body py-4">
        <div class="modul-grid">
          <!-- Satu blok = satu lajur. Kiri: Pengurusan Pengguna + Jadual Awalan.
               Kanan: Pamer Data, Lain-lain, Tetapan Sistem. Lihat `blokSeksyen`. -->
          <div v-for="blok in blokSeksyen" :key="blok.key" class="modul-blok">
            <section v-for="modul in blok.modul" :key="modul.text" class="modul">
              <div class="modul__head">
                <v-icon small class="mr-2" :color="COL.teal">{{ modul.icon }}</v-icon>
                <span class="modul__name">{{ $t(modul.text) }}</span>
                <v-spacer></v-spacer>
                <span class="modul__kira">{{ bilPautan(modul) }}</span>
              </div>

              <!-- Semua kandungan modul diinden di bawah tajuknya -->
              <div class="modul__body">
                <!-- pautan rata (tiada kumpulan) -->
                <div class="lnk-col">
                  <span
                    v-for="sub in pautanRata(modul)"
                    :key="sub.text"
                    class="lnk"
                    @click="goToRoute(sub.to)"
                  >
                    <v-icon small class="lnk__icon">{{ sub.icon }}</v-icon>
                    <span class="lnk__text">{{ $t(sub.text) }}</span>
                    <!-- Appears only once the pending check answers, so it can
                         never hold up the dashboard render. -->
                    <v-icon v-if="bilTertunggak(sub)" small class="lnk__alert"
                      :title="`${bilTertunggak(sub)} tindakan menunggu anda`">mdi-alert-circle</v-icon>
                    <v-icon small class="lnk__arrow">mdi-chevron-right</v-icon>
                  </span>
                </div>

                <!-- kumpulan bersarang -->
                <div v-for="sub in kumpulanBersarang(modul)" :key="sub.text" class="grp">
                  <div class="grp__label">
                    <v-icon small class="mr-2" :color="COL.teal">{{ sub.icon }}</v-icon>
                    {{ $t(sub.text) }}
                  </div>
                  <div class="lnk-col grp__links">
                    <span
                      v-for="child in sub.subLinks"
                      :key="child.text"
                      class="lnk"
                      @click="goToRoute(child.to)"
                    >
                      <v-icon small class="lnk__icon">{{ child.icon }}</v-icon>
                      <span class="lnk__text">{{ $t(child.text) }}</span>
                      <v-icon v-if="bilTertunggak(child)" small class="lnk__alert"
                        :title="`${bilTertunggak(child)} tindakan menunggu anda`">mdi-alert-circle</v-icon>
                      <v-icon small class="lnk__arrow">mdi-chevron-right</v-icon>
                    </span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import navsidebar from '@/model/navsidebar.js'
import { getUserEmail } from '@/services/emailScope.js'
import i18n from '@/i18n'
import axios from '@/plugins/axios'

import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

import lookupField from '@/services/lookupField'
const negeriLookup = new lookupField();

// Palet yang sama seperti kadarrespon.vue
const COL = { navy: "#0B1F3A", teal: "#0EA5A4", amber: "#E0A800", red: "#D9534F" };

// Kad ini mempunyai TEPAT dua lajur, dan isi setiap lajur ditetapkan di sini:
// lajur kiri ialah modul di bawah, lajur kanan ialah SEGALA yang lain mengikut
// susunan menu (Pamer Data, Lain-lain, Tetapan Sistem, …).
//
// Menyenaraikan lajur kiri sahaja — dan bukan kedua-duanya — bermakna modul baru
// dalam navsidebar.js muncul secara automatik di lajur kanan tanpa menyunting
// fail ini. Nama mesti SEPADAN TEPAT dengan `text` dalam navsidebar.js; ahli yang
// tiada bagi sesuatu peranan digugurkan begitu sahaja (BPM/BPHPP tiada
// Pengurusan Pengguna, jadi lajur kirinya hanya Jadual Awalan).
const LAJUR_KIRI = ['Modul Pengurusan Pengguna', 'Jadual Awalan'];

export default {
  name: 'PaparanUtama',

  data: () => ({
    COL,
    currentUser: '',
    peranan: '',
    namaNegeri: '',
    // Jam hidup: `sekarang` dikemas kini setiap saat supaya computed
    // tarikh/masa (dan salam pagi/petang/malam) ikut berubah.
    // Pemegang interval disimpan di luar `data` (tidak perlu reaktif).
    sekarang: new Date(),
    // Modul dijana daripada navsidebar.js supaya pautan sentiasa sepadan
    // dengan menu sebenar (dan tapisan peranan dikekalkan automatik).
    modules: [],
    // Kiraan tindakan tertunggak (Kawalan Penerbitan). Dimuat SELEPAS halaman
    // dipaparkan — null sehingga jawapan tiba, jadi tiada apa yang menunggu.
    tugasTertunggak: null,
  }),

  computed: {
    // Peranan + negeri dalam satu baris — cth. "PENYELIA (Selangor)".
    // Pengguna peringkat kebangsaan tiada negeri, jadi kurungan digugurkan.
    perananPenuh() {
      return this.namaNegeri ? `${this.peranan} (${this.namaNegeri})` : this.peranan
    },

    salam() {
      const j = this.sekarang.getHours()
      if (j < 12) return this.$t('Selamat Pagi')
      if (j < 19) return this.$t('Selamat Petang')
      return this.$t('Selamat Malam')
    },

    tarikhHariIni() {
      const d = this.sekarang
      const bulan = [
        'Januari', 'Februari', 'Mac', 'April', 'Mei', 'Jun',
        'Julai', 'Ogos', 'September', 'Oktober', 'November', 'Disember'
      ]
      return `${d.getDate()} ${bulan[d.getMonth()]} ${d.getFullYear()}`
    },

    // Jam 24-jam, dua digit — cth. "09:04:07"
    masaSekarang() {
      const d = this.sekarang
      const p = n => String(n).padStart(2, '0')
      return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
    },

    // Nama hari dalam Bahasa Melayu — getDay(): 0 = Ahad
    hariIni() {
      return ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu'][this.sekarang.getDay()]
    },

    // Kekalkan susunan menu: Pengurusan Pengguna → Pamer Data → Jadual Awalan.
    // "Lain-lain" ditambah selepasnya dalam template.
    modulBerkumpulan() {
      return this.modules.filter(m => m.subLinks && m.subLinks.length)
    },

    modulTunggal() {
      return this.modules.filter(m => !m.subLinks || !m.subLinks.length)
    },

    // Seksyen yang dipaparkan dalam kad tunggal. Modul pautan tunggal (Julat
    // Harga, Jejak Audit, Wajaran, …) digabung menjadi satu seksyen "Lain-lain"
    // supaya ia menggunakan laluan render yang sama seperti modul lain.
    // 'Tetapan Sistem' ialah penyelenggaraan sistem, bukan data tinjauan, jadi
    // ia dipaksa ke HUJUNG — selepas semua modul data dan selepas 'Lain-lain'.
    seksyenModul() {
      const adalahSistem = m => m.text === 'Tetapan Sistem'
      const seksyen = this.modulBerkumpulan.filter(m => !adalahSistem(m))
      if (this.modulTunggal.length) {
        seksyen.push({
          text: 'Lain-lain',
          icon: 'mdi-link-variant',
          subLinks: this.modulTunggal.map(m => ({
            text: m.text || m.title,
            to: m.to || m.url,
            icon: m.icon,
          })),
        })
      }
      seksyen.push(...this.modulBerkumpulan.filter(adalahSistem))
      return seksyen
    },

    // DUA lajur tetap: satu blok = satu sel grid, jadi modul di dalamnya
    // bertindan menegak dan tidak boleh terpisah ke lajur bertentangan.
    // Kiri mengikut LAJUR_KIRI; kanan ialah bakinya mengikut susunan menu.
    //
    // Lajur kosong tidak dirender langsung (cth. FE/DE tiada Jadual Awalan mahupun
    // Pengurusan Pengguna) — sel kosong hanya menghasilkan ruang lompang.
    blokSeksyen() {
      const diKiri = m => LAJUR_KIRI.includes(m.text)

      const kiri = LAJUR_KIRI
        .map(nama => this.seksyenModul.find(m => m.text === nama))
        .filter(Boolean)
      const kanan = this.seksyenModul.filter(m => !diKiri(m))

      return [kiri, kanan]
        .filter(lajur => lajur.length)
        .map(modul => ({ key: modul[0].text, modul }))
    },
  },

  async beforeMount() {
    const u = localStorageData.user() || {};
    this.currentUser = (u.name || '').toUpperCase();
    this.peranan = u.role || '';
    // Pengguna hanya menyimpan `kodneg` (cth. "10"), bukan nama negeri, jadi
    // kod itu dipadan dengan lookupnegeri (negeriID → negeri). Peranan
    // peringkat kebangsaan (ADMIN/BPM/BPHPP) tiada kodneg → kekal kosong.
    this.namaNegeri = await this.cariNamaNegeri(u.kodneg);

    // Kawalan Penerbitan hanya untuk pengguna berkebenaran penerbitan — peraturan
    // sama seperti sidebar (MenuHeader). Guna semula salinan cache-nya; jatuh
    // balik ke API jika cache belum wujud (cth. muat terus ke halaman ini).
    let penerbitanPerms = [];
    try {
      penerbitanPerms = JSON.parse(window.localStorage.getItem('penerbitanPerms') || '[]');
    } catch (e) { penerbitanPerms = []; }
    if (!Array.isArray(penerbitanPerms) || !penerbitanPerms.length) {
      try {
        const permRes = await axios.get(`${process.env.VUE_APP_API_URL}/penerbitan/permissions/me`);
        penerbitanPerms = (permRes.data && permRes.data.data && permRes.data.data.permissions) || [];
      } catch (e) { penerbitanPerms = []; }
    }

    const menu = await navsidebar(this.peranan, penerbitanPerms, await getUserEmail());
    // Buang 'Paparan Utama' / 'utama' — kita sudah berada di sini.
    this.modules = (menu || []).filter(m => m.to !== 'paparanutama' && m.url !== 'paparanutama');
  },

  mounted() {
    this._jamTimer = setInterval(() => { this.sekarang = new Date() }, 1000)
    // Deliberately NOT awaited and not part of created(): the dashboard must
    // render immediately, and a pending-work badge is not worth a moment of
    // blank page. It fills itself in once the answer arrives.
    this.muatTugasTertunggak()
  },

  // Wajib: tanpa ini interval terus berjalan selepas keluar halaman (kebocoran).
  beforeDestroy() {
    if (this._jamTimer) clearInterval(this._jamTimer)
  },

  methods: {
    /**
     * Pending Kawalan Penerbitan work for this user, fetched AFTER the page is
     * on screen. Failure is silent: the badge is a hint, and a dashboard that
     * errors because a hint could not load would be worse than no hint.
     */
    async muatTugasTertunggak() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/penerbitan/pending`)
        this.tugasTertunggak = (res.data && res.data.data) || null
      } catch (e) {
        this.tugasTertunggak = null
      }
    },
    // Does this menu link have work waiting behind it? Only Pamer Data HIES
    // has a source of counts today; the check is by route so adding another
    // later is a one-line change.
    bilTertunggak(sub) {
      if (!sub || sub.to !== 'pamerdatahies') return 0
      return (this.tugasTertunggak && this.tugasTertunggak.total) || 0
    },
    // kodneg → nama negeri. Kod dibanding sebagai String kerana lookupnegeri
    // memulangkan negeriID bertali ("01".."16") manakala kodneg kadang-kadang
    // nombor. Label hiasan sahaja: jika lookup gagal, pulangkan '' supaya
    // baris Peranan tetap terpapar tanpa kurungan.
    async cariNamaNegeri(kodneg) {
      if (!kodneg) return ''
      try {
        const res = await negeriLookup.getNegeri()
        const senarai = (res && res.data && res.data.data) || []
        const padan = senarai.find(n => String(n.negeriID) === String(kodneg))
        return padan ? padan.negeri : ''
      } catch (e) {
        return ''
      }
    },

    goToRoute(url) {
      if (!url) return
      this.$router.push(`/${i18n.locale}/${url}`, () => {})
    },

    // Jumlah pautan dalam satu modul (termasuk anak kumpulan).
    bilPautan(modul) {
      return (modul.subLinks || []).reduce(
        (n, s) => n + (s.subLinks ? s.subLinks.length : 1), 0
      )
    },

    // Pautan rata (tiada anak) — cth. Kadar Respon, Pengurusan Lampiran.
    pautanRata(modul) {
      return (modul.subLinks || []).filter(s => !s.subLinks)
    },

    // Kumpulan bersarang — cth. Pendapatan Isi Rumah, Kemudahan Asas.
    kumpulanBersarang(modul) {
      return (modul.subLinks || []).filter(s => s.subLinks)
    },
  },
}
</script>

<style scoped>
/* Mengikut kadarrespon.vue: padding 16px + membatalkan padding 12px
   `<v-container>` supaya kandungan memenuhi seluruh lebar <v-main>.

   -12px, BUKAN `calc(-50vw + 50%)`. Kedua-duanya bernilai sama TEPAT ketika
   tiada laci kiri, tetapi hack viewport itu menganggap bekas berada di TENGAH
   skrin. Dengan rel menu 56px, <v-main> teranjak ke kanan, jadi `50%` tidak
   lagi bersamaan `50vw` dan pengiraan itu menghasilkan -40px — menarik halaman
   ke bawah rel sehingga tepinya terpotong. -12px hanya membatalkan padding
   bekas, jadi ia betul sama ada rel wujud atau tidak. */
.paparan-utama {
  padding: 16px;
  margin-left: -12px;
  margin-right: -12px;
}

/* NOTA: halaman ini pernah diregangkan setinggi viewport (`min-height:
   calc(100vh - 84px)` + rantaian flex ke kad) supaya tiada ruang kosong di
   BAWAH kad. Ia ditarik balik: regangan itu tidak menghapuskan ruang kosong,
   ia cuma memindahkannya KE DALAM kad — dan kad berbingkai yang separuh kosong
   kelihatan seperti kandungan gagal dimuatkan, lebih teruk daripada kad pendek
   yang berakhir di hujung kandungannya. Biar kad mengikut saiz kandungan. */

/* ---------- Hero (khusus halaman utama) ----------
   Halaman lain memakai <PageHeader>: jalur cerah, teks teal, jubin ikon.
   Di sini sengaja DITERBALIKKAN — panel teal gelap, teks putih, wordmark
   survei — supaya halaman utama jelas berbeza dan terasa seperti akar sistem. */
.hero {
  position: relative;
  overflow: hidden;
  padding: 30px 32px 26px;
  background: linear-gradient(120deg, #01463e 0%, #026254 46%, #048374 100%);
  border-radius: 4px;
}
/* Latar carta: separuh kanan, dilindap ke kiri supaya teks kekal jelas. */
.hero__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  -webkit-mask-image: linear-gradient(90deg, transparent 30%, #000 70%);
  mask-image: linear-gradient(90deg, transparent 30%, #000 70%);
}
/* Skrin kecil: hero terlalu sempit untuk carta — sembunyikan supaya teks jelas. */
@media (max-width: 599px) {
  .hero__bg {
    display: none;
  }
}
.hero__inner {
  position: relative;
  z-index: 1;
}

/* Wordmark — pengenalan sistem, tidak wujud pada halaman lain. */
.hero__brand {
  display: inline-flex;
  align-items: baseline;
  gap: 10px;
  padding-bottom: 12px;
  margin-bottom: 14px;
  border-bottom: 2px solid rgba(127, 233, 221, .35);
}
.hero__brand-mark {
  font-size: var(--fs-base);
  font-weight: 800;
  letter-spacing: 3px;
  color: #ffffff;
}
.hero__brand-slash {
  color: #7fe9dd;
  margin: 0 1px;
}
.hero__brand-year {
  font-size: var(--fs-base);
  font-weight: 500;
  letter-spacing: 1.4px;
  color: #7fe9dd;
}

.hero__title {
  font-size: var(--fs-3xl);
  font-weight: 300;
  line-height: 1.2;
  color: rgba(255, 255, 255, .82);
  margin: 0;
}
.hero__name {
  font-weight: 700;
  color: #ffffff;
}
.hero__sub {
  font-size: var(--fs-base);
  color: rgba(190, 240, 232, .85);
  margin: 8px 0 0;
  max-width: 52ch;
  line-height: 1.5;
}

/* Maklumat sesi — jalur di bawah tajuk, dipisah garis menegak nipis. */
.hero__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 0;
  margin: 22px 0 0;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, .14);
}
.hero__meta-item {
  padding: 0 24px;
  border-left: 1px solid rgba(255, 255, 255, .14);
}
.hero__meta-item:first-child {
  padding-left: 0;
  border-left: 0;
}
.hero__meta dt {
  font-size: var(--fs-3xs);
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #7fe9dd;
  margin-bottom: 4px;
}
.hero__meta dd {
  margin: 0;
  font-size: var(--fs-base);
  font-weight: 600;
  color: #ffffff;
  line-height: 1.3;
}
/* Jam: lebar digit tetap supaya teks tidak bergoyang setiap saat. */
.hero__clock {
  font-variant-numeric: tabular-nums;
  letter-spacing: .5px;
}

/* Menggantikan kelas `subtitle-2` Vuetify (0.875rem, tetap): tajuk kad kini
   mengikut tangga taip yang sama seperti seluruh sistem. */
.akses__tajuk {
  font-size: var(--fs-lg);
  font-weight: 700;
  letter-spacing: .2px;
}

/* ---------- Kad Akses Pantas ----------
   Hiasan carta di sudut kanan bawah: sangat lut sinar, di belakang kandungan,
   dan tidak boleh diklik. */
.akses {
  position: relative;
  overflow: hidden;
}
/* Gelang sengaja BESAR dan dilabuhkan ke sudut kanan bawah: apabila kandungan
   pendek, bahagian bawah kad kelihatan DIHIAS, bukan sekadar kosong. `max-width`
   mengekang supaya ia tidak pernah merentasi lajur pautan pada skrin sempit,
   dan opasiti kekal rendah supaya teks di atasnya tidak terganggu. */
.akses__bg {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 820px;
  max-width: 78%;
  height: auto;
  opacity: .13;
  pointer-events: none;
  user-select: none;
  z-index: 0;
}
/* Kandungan mesti di atas hiasan supaya pautan boleh diklik. */
.akses__body {
  position: relative;
  z-index: 1;
}
/* Skrin kecil: ruang terlalu sempit — hiasan hanya menambah kekusutan. */
@media (max-width: 599px) {
  .akses__bg {
    display: none;
  }
}

/* DUA lajur tetap: kiri = Pengurusan Pengguna + Jadual Awalan, kanan = bakinya.
   Setiap lajur ialah SATU sel grid yang mengandungi beberapa modul bertindan,
   jadi tiada apa-apa yang boleh melompat ke lajur bertentangan.

   `minmax(0, 1fr)` — bukan `1fr` — supaya lajur dibenarkan mengecut lebih kecil
   daripada kandungan terpanjangnya; dengan `1fr` sahaja, satu nama pautan yang
   panjang boleh menolak grid melebihi lebar kad.

   `align-items: start` — lajur pendek berakhir di hujung kandungannya, bukan
   diregangkan setinggi lajur Jadual Awalan.

   Nota untuk masa depan: susun atur ini MEMANG meninggalkan ruang di bawah lajur
   kanan, kerana lajur kiri jauh lebih tinggi. Itu pilihan yang disengajakan —
   susunan yang boleh diteka lebih diutamakan daripada pembungkusan yang ketat.
   Percubaan terdahulu (`columns: 320px 4` mengalir automatik) memang memampatkan
   ruang tetapi menyusun modul di tempat yang tidak dapat diramal. */
.modul-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 28px 40px;
  align-items: start;
}

/* Telefon: dua lajur pada lebar ~360px bermakna ±160px sesalur — nama pautan
   seperti "Pengurusan Lampiran" membalut kepada tiga baris dan hierarki hilang.
   Di sini lajur kanan jatuh ke bawah lajur kiri. */
@media (max-width: 599px) {
  .modul-grid {
    grid-template-columns: 1fr;
  }
}
/* Skrin sederhana: kekal dua lajur, cuma jurangnya dirapatkan. */
@media (min-width: 600px) and (max-width: 959px) {
  .modul-grid {
    gap: 24px 20px;
  }
}

/* Jarak ANTARA modul dalam lajur yang sama (Jadual Awalan di bawah Pengurusan
   Pengguna). Modul terakhir tidak perlu ekor. */
.modul {
  margin-bottom: 28px;
}
.modul:last-child {
  margin-bottom: 0;
}

/* ---------- Seksyen modul (dalam kad) ---------- */
.modul__head {
  display: flex;
  align-items: center;
  padding-bottom: 6px;
  margin-bottom: 8px;
  border-bottom: 1px solid #e6f6f5;
}
/* Tiga aras kad ini SENGAJA memakai tangga yang sama seperti menu sisi —
   modul 18px, kumpulan 17px, pautan 16px. Kad ini memaparkan navigasi yang
   serupa dengan laci, jadi jika saiznya berbeza, dua permukaan yang menunjukkan
   perkara yang sama akan kelihatan seperti dua sistem berasingan. */
.modul__name {
  font-size: var(--fs-lg);
  font-weight: 700;
  color: #037769;
  letter-spacing: .2px;
}

/* Bilangan pautan — menggantikan `caption grey--text`. Kekal jauh lebih kecil
   daripada nama modul: ia metadata, bukan tajuk. */
.modul__kira {
  font-size: var(--fs-2xs);
  color: #78909c;
}

/* ---------- Kumpulan bersarang ---------- */
.grp {
  margin-top: 14px;
}
.grp__label {
  display: flex;
  align-items: center;
  font-size: var(--fs-ml);
  font-weight: 700;
  color: #0f2f2a;
  margin-bottom: 4px;
}
/* Aras 3 — pautan anak diinden lagi daripada label kumpulannya. Garis panduan
   di sini lebih pekat (teal) daripada garis modul supaya dua aras inden itu
   tidak kelihatan sama berat. */
.grp__links {
  padding-left: 14px;
  border-left: 2px solid #cfeae7;
}

/* ---------- Pautan ----------
   Kekal satu lajur menegak: pengimbangan ruang kini dibuat pada aras seksyen
   (aliran multi-column di atas), jadi pautan tidak perlu berpecah lajur sendiri
   — pautan berbilang lajur di dalam seksyen menyukarkan pembacaan hierarki. */
.lnk-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
/* Aras 2 — semua kandungan di bawah tajuk modul diinden supaya tajuk
   (Jadual Awalan) jelas berbeza daripada pautannya (Kadar Respon). */
.modul__body {
  padding-left: 14px;
  border-left: 2px solid #eef7f6;
}
/* Pautan teks (bukan butang), sasaran klik selesa. */
.lnk {
  display: inline-flex;
  align-items: flex-start;
  cursor: pointer;
  font-size: var(--fs-base);
  line-height: 1.5;
  padding: 5px 0;
  color: #37474f;
  transition: color .15s ease;
}
/* Ikon: saiz tetap, kekal sebaris dengan baris pertama teks bila teks membalut. */
.lnk__icon {
  flex: none;
  margin-right: 8px;
  margin-top: 2px;
  color: #90a4ae !important;
  transition: color .15s ease;
}
/* Garis bawah hanya di bawah teks, bukan ikon atau anak panah. */
.lnk__text {
  border-bottom: 1px solid transparent;
}
/* Anak panah: penunjuk bahawa teks ini boleh diklik. Sentiasa kelihatan
   (samar) supaya afordans jelas walaupun tanpa tuding tetikus — pengguna
   skrin sentuh tidak pernah "hover". Ia menyerlah dan menganjak ke kanan
   apabila dituding. */
/* Pending-work marker. Sits before the arrow so the row layout is unchanged
   when nothing is pending — the icon simply appears in place. */
.lnk__alert {
  flex: none;
  margin-left: 4px;
  color: #d32f2f !important;
  animation: lnk-alert-pulse 2s ease-in-out infinite;
}
@keyframes lnk-alert-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
}
@media (prefers-reduced-motion: reduce) {
  .lnk__alert { animation: none; }
}
.lnk__arrow {
  flex: none;
  margin-left: 4px;
  margin-top: 2px;
  color: #b6cdc9 !important;
  /* Kekal sedikit lebih besar daripada teks pautannya, seperti sebelum ini
     (dahulu 16px ikon / 14px teks) — anak panah yang lebih kecil daripada teks
     kelihatan seperti tersalah jajar, bukan seperti afordans. */
  font-size: var(--fs-lg) !important;
  transition: color .15s ease, transform .15s ease;
}
.lnk:hover {
  color: #037769;
}
.lnk:hover .lnk__text {
  border-bottom-color: #037769;
}
.lnk:hover .lnk__icon {
  color: #0ea5a4 !important;
}
.lnk:hover .lnk__arrow {
  color: #037769 !important;
  transform: translateX(3px);
}
.lnk:focus-visible {
  outline: 2px solid #037769;
  outline-offset: 2px;
}
/* Hormati tetapan sistem: jangan animasi jika pengguna memintanya. */
@media (prefers-reduced-motion: reduce) {
  .lnk__arrow {
    transition: none;
  }
  .lnk:hover .lnk__arrow {
    transform: none;
  }
}
</style>
